export default  {
    path: 'product_selection',
    name: 'productSelection_',
    component: () => import('@/pages/lb/product_selection/SelectionDrawer'),
    meta: { title: '直播选品' },
}
